"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".mat-menu-item[disabled][_ngcontent-%COMP%]{color:#7f8fa4!important}.mat-menu-item[disabled][_ngcontent-%COMP%]:hover{background-color:#fff}"];
exports.styles = styles;
